:host {
	grid-column: span var(--smoothly-table-cell-span, 1);
	display: flex;
	align-items: center;
	padding-inline: var(--smoothly-table-cell-padding-inline, 1.1rem);
	min-height: var(--smoothly-table-cell-min-height, 2.75rem);
	white-space: nowrap;
}
